import { useEffect, useRef, useState } from "react";

export function useStickyHead() {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;

    let io: IntersectionObserver | null = null;

    const make = () => {
      const topH =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue(
            "--app-top-h",
          ),
        ) || 0;
      io?.disconnect();
      io = new IntersectionObserver(
        ([entry]) => setStuck(!!entry && !entry.isIntersecting),
        { rootMargin: `-${topH}px 0px 0px 0px`, threshold: [0, 1] },
      );
      io.observe(el);
    };

    make();

    const top = document.querySelector(".app-top");
    const ro = top ? new ResizeObserver(make) : null;
    if (top && ro) ro.observe(top);

    return () => {
      io?.disconnect();
      ro?.disconnect();
    };
  }, []);

  return { sentinelRef, stuck };
}
